<script>
/**
 * Descripción: BaseCard reutilizable
 *
 * @displayName BaseFeed
 */

const BaseCard = () =>
  import(
    /* webpackChunkName: "BlogViewComponent" */ '@/components/core/forms/BaseCard'
  );

export default {
  name: 'BaseFeedCard',

  props: {
    size: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    BaseCard
  }
};
</script>

<template>
  <v-col cols="12" :md="size === 2 ? 6 : size === 3 ? 4 : undefined">
    <BaseCard
      :height="value.prominent ? 450 : 350"
      color="grey lighten-1"
      dark
      :to="'/' + value.slug"
    >
      <v-img
        v-if="value.featured_image"
        :src="value.featured_image"
        height="100%"
        gradient="rgba(0, 0, 0, .42), rgba(0, 0, 0, .42)"
      >
        <v-row v-if="!value.prominent" class="fill-height text-right ma-0">
          <v-col cols="12">
            <v-chip
              label
              class="mx-0 mb-2 text-uppercase"
              color="grey darken-3"
              text-color="white"
              small
              @click.stop
              >{{ value.categories[0].name }}</v-chip
            >

            <h3 class="title font-weight-bold mb-2">{{ value.title }}</h3>

            <div class="caption">
              {{ value.author.first_name }} {{ value.author.last_name }}
              <br />
              {{ value.author.published }}
            </div>
          </v-col>

          <v-col align-self="end">
            <v-chip
              class="text-uppercase ma-0"
              color="#2c3e50"
              label
              small
              @click.stop
              >Leer Más</v-chip
            >
          </v-col>
        </v-row>
      </v-img>
    </BaseCard>
  </v-col>
</template>

<style>
.v-image__image {
  transition: 0.3s linear;
}
</style>
